import React from 'react'
import PropTypes from 'prop-types'

import CopyBlock from './CopyBlock'
import MediaBlock from './MediaBlock'
import { SectionContainer, MobileMediaWrapper, DesktopMediaWrapper } from './styles'

export default function TextAndMediaBlock({
  heading,
  description,
  useBullets = false,
  descriptionList = [],
  useCTA,
  resourceUrl,
  isVideo,
  textLeft,
  ctaText,
  ctaLink,
  ctaVariant,
  ctaAnalytics,
  altText,
  backgroundColor,
}) {
  return (
    <SectionContainer bkgColor={backgroundColor}>
      <MobileMediaWrapper>
        <MediaBlock resourceUrl={resourceUrl} altText={altText} isVideo={isVideo} />
      </MobileMediaWrapper>
      {textLeft ? (
        <>
          <CopyBlock
            heading={heading}
            useBullets={useBullets}
            descriptionList={descriptionList}
            description={description}
            useCTA={useCTA}
            ctaText={ctaText}
            ctaLink={ctaLink}
            ctaVariant={ctaVariant}
            ctaAnalytics={ctaAnalytics}
            textLeft={textLeft}
          />
          <DesktopMediaWrapper>
            <MediaBlock resourceUrl={resourceUrl} altText={altText} isVideo={isVideo} />
          </DesktopMediaWrapper>
        </>
      ) : (
        <>
          <DesktopMediaWrapper>
            <MediaBlock resourceUrl={resourceUrl} altText={altText} isVideo={isVideo} />
          </DesktopMediaWrapper>
          <CopyBlock
            heading={heading}
            useBullets={useBullets}
            descriptionList={descriptionList}
            description={description}
            useCTA={useCTA}
            ctaText={ctaText}
            ctaLink={ctaLink}
            ctaVariant={ctaVariant}
            ctaAnalytics={ctaAnalytics}
          />
        </>
      )}
    </SectionContainer>
  )
}

TextAndMediaBlock.propTypes = {
  heading: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  useBullets: PropTypes.bool.isRequired,
  descriptionList: PropTypes.array.isRequired,
  useCTA: PropTypes.bool.isRequired,
  resourceUrl: PropTypes.string.isRequired,
  isVideo: PropTypes.bool.isRequired,
  textLeft: PropTypes.bool.isRequired,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
  ctaVariant: PropTypes.bool,
  ctaAnalytics: PropTypes.string,
  altText: PropTypes.string,
  backgroundColor: PropTypes.string,
}
